<script lang="ts" setup>
import TabDropdown from '@app/components/parts/topBar/tabDropdown.vue';

const props = withDefaults(
    defineProps<{
        menu?: {
            tabs?: Array<object>;
        };
    }>(),
    {
        menu: () => {
            return {};
        },
    },
);
</script>
<template>
    <ul
        class="font-brand @[640px]/topBar:flex-shrink-0 @[640px]/topBar:pl-0 @[1024px]/topBar:text-[15px] @[1280px]/topBar:text-[16px] @[1536px]/topBar:text-lg m-0 flex w-auto list-none items-stretch space-x-1 self-stretch p-0 pl-2 text-sm"
    >
        <TabDropdown
            v-for="(tab, index) in props.menu.tabs"
            :key="index"
            :tab="tab"
            :menu="props.menu"
        ></TabDropdown>
    </ul>
</template>
